import type { ReactNode } from "react";

export function Card({
  children,
  className = "",
  id,
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section
      id={id}
      className={`rounded-2xl border border-stone-200 bg-white p-5 shadow-sm ${className}`}
    >
      {children}
    </section>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-xl border border-dashed border-stone-200 p-8 text-center text-sm text-stone-400">
      {children}
    </p>
  );
}

export function Spinner({ label }: { label?: string }) {
  return (
    <p className="flex items-center gap-2 text-sm text-stone-500">
      <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-stone-300 border-t-stone-600" />
      {label ?? "Chargement…"}
    </p>
  );
}

export function Skeleton({ count = 3, className = "h-28" }: { count?: number; className?: string }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={`sv-skeleton rounded-2xl ${className}`} />
      ))}
    </div>
  );
}
